// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__pgu_J","details":"styles_details__ta2XU","opacity50":"styles_opacity50__SuR4O"};